var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.5,
    r: 15,
    fill: "#D4D6D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262929",
    fillRule: "evenodd",
    d: "M18.333 10.833v-.666c0-.737-.597-1.334-1.333-1.334h-4c-.736 0-1.333.597-1.333 1.334v.666h-2a.667.667 0 0 0 0 1.334h.666V19.5a2 2 0 0 0 2 2h5.334a2 2 0 0 0 2-2v-7.333h.666a.667.667 0 1 0 0-1.334zM17 10.167h-4v.666h4zm1.333 2h-6.666V19.5c0 .368.298.667.666.667h5.334a.667.667 0 0 0 .666-.667z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#262929",
    d: "M13 13.5h1.333v5.333H13zM15.667 13.5H17v5.333h-1.333z"
  })));
};
export default SvgTrash;